<template>
    <div class="my-profile-page">
        <MyProfile :isPending="true" :isMyProfile="true" :editionMode="true" />
    </div>
</template>

<script>
import MyProfile from '@/components/my-profile/MyProfile'

export default {
    components: { MyProfile },
    data() {
        return {
            profileData: {},
            message: null
        }
    },
    methods: {
        fetchData() {
            this.profileData = {
                starsNumber: 0,
                profileName: '',
                initiativeDescription: '',
                email: '',
                city: 'São Paulo - SP',
                partners: [],
                connectionsNumber: 0,
                evaluationNumber: 0,
                compatibility: 0,
                selectedStatus: [1, 2, 3, 4, 5, 6, 7, 8, 9]
            }
        }
    },
    computed: {
        getProfileData() {
            return this.profileData
        }
    },
    mounted() {
        this.fetchData()
    }
}
</script>

<style scope src="./MyProfilePage-light-theme.css"></style>



// WEBPACK FOOTER //
// src/pages/private/dashboard-page/my-profile-page/MyProfilePage.vue